//External Libraries
import * as React from "react";
import { MSISDNEntryFailure, MSISDNEntrySuccess } from "ouisys-clients/dist/clients/tallyman.v1-pin/HOC";
import * as RDS from "ouisys-clients/dist/common-types/RemoteDataState";
import PhoneInput from "ouisys-phone-input/dist/common/PhoneInput";
import Loader from "../Loader/index";
import PricePoint from "ouisys-clients/dist/clients/legal-components/price-point"

//Translations
import { Translate, injectIntl, legals } from "../../localization/index";
import "./PhoneNumberEntryStep.scss";


class PhoneNumberEntryStep extends React.PureComponent<{
  msisdn: string;
  locale: string;
  rds: RDS.RemoteDataState<MSISDNEntryFailure, MSISDNEntrySuccess>;
  onEnd: (msisdn: string, extraParams?: { [key: string]: string }) => void;
}> {
  state = {
    msisdn: this.props.msisdn,
    internationalNumber: this.props.msisdn,
    isValid: false,
    // adds translation to the Placeholder text - needs to go to backend one day
    holderTxt: ""
  };
  phoneInputRef = React.createRef<HTMLInputElement>()

  componentDidMount(){

    var loc = this.props.locale;

      const lang = {
        en:"Mobile Number",
        no:"Mobilnummeret"
      }

        for (let key in lang) {

        let value = lang[key];

           this.setState({holderTxt:lang[loc]});

        }

  }

  render() {
    return (
      <div className="number-entry">
        <h1><Translate id="enterMobileNumber" defaultMessage="Put your mobile number below" /></h1>
        <form
          onSubmit={ev => {
            ev.preventDefault();
            // you can pass the operator here as the second parameter to onEnd:
            // this.props.onEnd(this.state.bupperNumber, {operator: "EG_VODAFONE"})
            this.props.onEnd(this.state.internationalNumber.match(/\d+/gi).join(''));
          }}
        >

          <PhoneInput
            inputElementRef={this.phoneInputRef}
            placeholder={this.state.holderTxt}
            msisdn={this.state.msisdn}
            countryCode={process.env.country}
            showFlag={false}
            showMobileIcon={true}
            showError={true}
            onChange={({ msisdn, isValid, internationalNumber, ...args }) => {
              console.log(args, internationalNumber)
              this.setState({ msisdn, isValid, internationalNumber })
            }
            }

          />

          {
            RDS.WhenLoading(null, () => <div className="msg">
              <Loader />
              <p><Translate id="msgWait" defaultMessage="Please wait..." /></p>
            </div>)(this.props.rds)
          }

          <div className="error">
            {RDS.WhenFailure(null, (err: MSISDNEntryFailure) => (
              <Translate id={err.errorType} />
            ))(this.props.rds)}
          </div>

          <button type="submit" className="btn submit-msisdn" disabled={RDS.IsLoading(this.props.rds) || !this.state.isValid}><Translate id="btnMsisdn" defaultMessage="Confirm my number" /></button>

          <PricePoint className="price-point" locale={this.props.locale} legals={legals} />
        </form>
      </div>
    );
  }
}

export default injectIntl(PhoneNumberEntryStep);